export default {
  'unknownError.title':
    "Hay aksi! <color>Examod</color>'da bir şeyler yanlış gitti.",
  'unknownError.desc':
    'İsteğiniz işlenirken beklenmeyen bir hata oluştu. Sorunu en kısa sürede çözeceğiz.',
  'unknownError.toHome': 'Kullanıcı Paneline Dön',
};
